<template>
	<div>
		<v-navigation-drawer
			:value="value"
			:permanent="$vuetify.breakpoint.mdAndUp"
			app
			right
			clipped
			:mini-variant="isMini"
			mini-variant-width="56"
			@input="toggleDrawer"
		>
			<template #prepend>
				<template v-if="profile">
					<v-list-item two-line>
						<v-list-item-action>
							<v-avatar size="24">
								<v-icon color="primary">mdi-account</v-icon>
							</v-avatar>
						</v-list-item-action>

						<v-list-item-content>
							<v-list-item-title>{{ profile.fullName }}</v-list-item-title>
							<v-list-item-subtitle>{{ profile.userGroup }}</v-list-item-subtitle>
						</v-list-item-content>

						<v-list-item-action>
							<v-icon color="primary" @click="logout">mdi-exit-run</v-icon>
						</v-list-item-action>
					</v-list-item>

					<v-list-item to="/dashboard/home">
						<v-list-item-action>
							<v-avatar size="24" tile>
								<v-icon color="primary">mdi-view-dashboard</v-icon>
							</v-avatar>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>
								لوحة التحكم
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</template>

				<v-list-item v-else two-line @click="showLogin = !showLogin">
					<v-list-item-action>
						<v-avatar size="24">
							<v-icon color="primary">mdi-login</v-icon>
						</v-avatar>
					</v-list-item-action>

					<v-list-item-content>
						<v-list-item-title>تسجيل دخول</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</template>

			<v-list class="pt-0">
				<template v-for="object in objects">
					<v-divider v-if="object.divider" :key="object.name"></v-divider>
					<v-list-item v-else :key="object.name" :to="object.link" :disabled="object.disabled">
						<v-list-item-action>
							<v-avatar size="24" tile>
								<v-img v-if="object.icon.length > 20" contain :src="object.icon"></v-img>
								<v-icon v-else :color="object.disabled ? '' : 'primary'">{{ object.icon }}</v-icon>
							</v-avatar>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>{{ object.name }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</template>
			</v-list>

			<template #append>
				<v-list>
					<v-list-item href="https://bitcode.sa/" target="_blank">
						<v-list-item-action>
							<v-avatar size="24">
								<v-img contain src="@/assets/bitcode-logo.png"></v-img>
							</v-avatar>
						</v-list-item-action>
						<v-list-item-title>تطوير مؤسسة BitCode</v-list-item-title>
					</v-list-item>
				</v-list>
			</template>
		</v-navigation-drawer>
		
		<app-login v-if="showLogin" v-model="showLogin"></app-login>
	</div>
</template>

<script>
import rulesMixin from "@/mixins/rules-mixin";

export default {
	components: {
		"app-login": require("@/components/app/AppLogin").default
	},
	mixins: [rulesMixin],
	data() {
		return {
			showLogin: false
		};
	},
	computed: {
		value() {
			return this.$store.state.drawer;
		},
		isMini() {
			if(this.$vuetify.breakpoint.mdAndUp){
				return this.$store.state.mini;
			} else {
				return false;
			}
		},
		objects() {
			return [
				{ divider: true },
				{ name: "الرئيسية", icon: "mdi-home-circle", link: "/" },
				{
					name: "الدورات التدريبية",
					icon: "mdi-teach",
					link: "/courses"
				},
				{
					name: "الأخبار العامة",
					icon: "mdi-newspaper",
					link: "/news"
				},
				{
					name: "النقل ببديل",
					icon: "mdi-account-switch",
					link: "/replacement"
				},
				{
					name: "الفعاليات",
					icon: "mdi-calendar",
					link: "/events"
				},
				{
					name: "الوظائف الطبية",
					icon: "mdi-doctor",
					link: "/jobs",
				},
				{
					name: "المكتبة الطبية",
					icon: "mdi-library",
					link: "/library",
				},
				{ name: "المساعدة", icon: "mdi-message-alert", disabled: true },
				{ divider: true, disabled: true },
				{
					name: "مشاركة التطبيق",
					icon: "mdi-share-variant",
					disabled: true
				}
			];
		},
		profile() {
			return this.$store.state.profile;
		}
	},
	watch: {
		showLogin() {
			if (!this.$vuetify.breakpoint.mdAndUp) {
				this.$store.dispatch("setDrawer", false);
			}
		}
	},
	created() {
		if (!this.$vuetify.breakpoint.mdAndUp) {
			this.$store.dispatch("setDrawer", false);
		}
	},
	methods: {
		toggleMini() {
			this.$store.dispatch("setMini", !this.$store.state.mini);
		},
		toggleDrawer(value) {
			this.$store.dispatch("setDrawer", value);
		},
		logout() {
			setTimeout(() => {
				this.$store.dispatch("setToken", null);
			}, 50);
		}
	}
};
</script>